export enum adminAdministratorsTypes {
    FETCH_ADMIN_ADMINISTRATORS_REQUEST = "FETCH_ADMIN_ADMINISTRATORS_REQUEST",
    FETCH_ADMIN_ADMINISTRATORS_SUCCESS = "FETCH_ADMIN_ADMINISTRATORS_SUCCESS",
    FETCH_ADMIN_ADMINISTRATORS_FAILURE = "FETCH_ADMIN_ADMINISTRATORS_FAILURE",
  }